import ActivoService from "@/api/services/finanzas/ActivoService"
import Vue from "vue"

const state = () => ({
    activos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "-fecha_ingreso",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    ACTIVOS: state => {
        return state.activos
    },
    ACTIVOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_ACTIVOS: (state, payload) => {
        state.activos = payload
    },

    SET_ACTIVOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ACTIVO: (state, payload) => {
        state.activos.push(payload)
    },

    UPDATE_ACTIVO: (state, payload) => {
        state.activos = state.activos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_ACTIVO: (state, payload) => {
        state.activos = state.activos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_ACTIVOS: async ({ commit, state }, { filter, activoEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (activoEstado === "4") {
                customfilter = `fecha_ingreso=${new Date().toISOString().substr(0, 10)}`
            }

            if (activoEstado === "5") {
                customfilter = `fecha_baja=${new Date().toISOString().substr(0, 10)}`
            }

            let { data, status, headers } = await ActivoService.get({
                filter,
                activoEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_ACTIVOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los activos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ACTIVO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ActivoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_ACTIVO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_RECORDS_ACTIVOS: async ({ commit }) => {
        try {
            let { data, status } = await ActivoService.getAllRecords()
            if (status === 200) {
                commit("SET_ACTIVOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los activos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ACTIVO_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await ActivoService.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_ACTIVO", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_ACTIVO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ActivoService.post(payload)
            if (status === 201) {
                commit("ADD_ACTIVO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El activo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_ACTIVO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ActivoService.put(payload)
            if (status === 200) {
                commit("UPDATE_ACTIVO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El activo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_ACTIVO: async ({ commit }, payload) => {
        try {
            let { status, data } = await ActivoService.delete(payload)
            if (status === 204) {
                commit("DELETE_ACTIVO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El activo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_ACTIVO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El activo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
